import type { AccountSummary } from '@fruitful/types';
import * as React from 'react';
import {
    BodyMediumEmphasized,
    FootnoteRegular,
    HolisticAccountLogo,
    XStack,
    YStack,
} from 'smoothie';

interface ApexAccountLineItemProps {
    account: AccountSummary;
}

// TODO jason
//   Move to shared package _after_ IM launch

export const ApexAccountLineItem = ({ account }: ApexAccountLineItemProps) => {
    return (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            gap={16}
            cursor="pointer"
            hoverStyle={{ backgroundColor: '$gray100' }}
            $sm={{ padding: 8, borderRadius: 12 }}
        >
            <XStack
                alignItems="center"
                gap={16}
                flexShrink={1}
                $platform-web={{ flexGrow: 1 }}
            >
                <HolisticAccountLogo
                    institutionName={account.institutionName}
                    logo={account.logo}
                    provider={account.provider}
                />
                <XStack
                    flex={1}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <YStack flex={1}>
                        <BodyMediumEmphasized>
                            {account.name ?? 'Investment account'}
                        </BodyMediumEmphasized>
                        <XStack alignItems="center" gap={8}>
                            <FootnoteRegular color="$gray1000">
                                {account.id}
                            </FootnoteRegular>
                        </XStack>
                    </YStack>
                </XStack>
            </XStack>
        </XStack>
    );
};
